import { render, staticRenderFns } from "./WsSocialiteBtnGoogle001.vue?vue&type=template&id=df974404"
import script from "./WsSocialiteBtnGoogle001.vue?vue&type=script&lang=js"
export * from "./WsSocialiteBtnGoogle001.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports